export default "__VITE_ASSET__BYc0qo1U__"